export const LANDING_CARDS = [
    {
      id: 1,
      appCode: "MP",
      title: "Material Planning",
      disabled: false,
      url: process.env.REACT_APP_MATERIAL_PLANNING_URL,
      className: 'material-planning'
    },
    {
      id: 2,
      appCode: "DP",
      title: "Demand Planning",
      url: process.env.REACT_APP_DEMAND_PLANNING_URL,
      disabled: false,
      className: 'demand-planning'
    },
    {
      id: 3,
      appCode: "CT",
      title: "Command Center",
      url: process.env.REACT_APP_COMMAND_CENTER_URL,
      disabled: false,
      className: 'control-tower'
    },
    //--TODO supply-planning url
    {
      id: 4,
      appCode: "Supply Planning",
      title: "Supply Planning",
      url: '/supply-planning/ruleLevel',
      disabled: false,
      className: 'sp'
    },
    //--TODO inventory-optimization url
    {
      id: 5,
      appCode: "IO",
      title: "Inventory\nOptimization",
      url: 'inventory-optimization',
      disabled: false,
      className: 'io'
    },
    {
      id: 8,
      appCode: "UR",
      title: "User Access\nManagement",
      url: '/user-roles/new-request',
      disabled: false,
      className: 'user-roles'
    },
    {
      id: 9,
      appCode: "SOP",
      title: "S&OP",
      description: "Sales & Operations\nPlanning",
      url: 'https://isop.devko.com',
      disabled: false,
      className: 'sop-application'
    }
  ]
